module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "lefki.e4ff7aa6.jpg";